import enums from "./../enums";

const documents = (
	state = {
		allDocuments: [],
		documentsLoading: false,
	},
	{ type, payload }
) => {
	switch (type) {
		case enums.GET_ALL_DOCUMENTS: {
			return {
				...state,
				allDocuments: payload.documents,
			};
		}
		case enums.GET_ALL_DOCUMENTS_LOADING: {
			return { ...state, documentsLoading: payload };
		}
		default:
			return { ...state };
	}
};

export default documents;
